import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const VideoPlayer = () => {
    return (
        <Container  maxWidth={'lg'} disableGutters sx={{ marginBottom: '50px', marginTop: '50px' }}>
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '500px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                {/* Video element */}
                <video
                    controls
                    autoPlay
                    loop
                    muted
                    playsInline
                    src="/video.mp4"
                    style={{
                        objectFit: 'cover',
                        borderRadius: '8px',
                        width: '100%',
                        height: '100%',
                    }}
                ></video>

                {/* Overlay Box */}
                <Box
                    sx={{
                        position: 'absolute',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        textShadow: '0 0 20px #000',
                        fontWeight: 600,
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                    }}
                >
                    <Typography variant="h4" align="center">
                        {/* Бүсчилсэн хөгжлийн үндэсний хүрээлэн */}
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
};

export default VideoPlayer;
